import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddObjectionResponse } from '../api/addObjectionResponse';
import { useEditObjectionResponse } from '../api/editObjectionResponse';
import { objectionResponsesTypes } from '../types';

import { ObjectionResponseForm } from './ObjectionResponseForm';

type ModalProps = {
  aiId: number;
  mode: 'create' | 'edit';
  response?: objectionResponsesTypes.ObjectionResponse;
};

export const ObjectionResponseModal = NiceModal.create(({ aiId, mode, response }: ModalProps) => {
  const modal = useModal();

  const { mutate: addMutate, isLoading: isAddLoading } = useAddObjectionResponse({
    config: {
      onSuccess: () => modal.hide(),
    },
  });

  const { mutate: editMutate, isLoading: isEditLoading } = useEditObjectionResponse({
    config: {
      onSuccess: () => modal.hide(),
    },
  });

  const isSubmitting = mode === 'create' ? isAddLoading : isEditLoading;

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title={mode === 'create' ? 'Add Objection Response' : 'Edit Objection Response'}
    >
      <ObjectionResponseForm
        aiId={aiId}
        initial={mode === 'edit' ? response : undefined}
        onSubmit={(values) => {
          if (mode === 'create') {
            addMutate(values);
            return;
          }

          if (!response) return;

          editMutate({ id: response._id, ...values });
        }}
        submitLabel={mode === 'create' ? 'Create' : 'Save'}
        isSubmitting={isSubmitting}
      />
    </Modal>
  );
});
